module.exports = __webpack_public_path__ + "static/media/restoreIconDeleted.74b76900.svg";